/**
 * SetupKioskConnectionUseCase
 *
 * Use case for setting up or updating the Kiosk connection for an operator.
 * Creates the connection between the operator and the Nayax Kiosk service.
 */

import type { OcpiAdminRepository } from '../data/ocpi-admin-repository';

export class SetupKioskConnectionUseCase {
  constructor(private readonly repository: OcpiAdminRepository) {}

  /**
   * Execute setup Kiosk connection operation
   *
   * @param operatorId - Nayax operator ID
   */
  async execute(operatorId: number): Promise<void> {
    await this.repository.setupKioskConnection(operatorId);
  }
}
